/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useCallback } from "react";
import { useBooking } from "./useBooking";

export const useAuthSuccessHandler = ({ form, onSubmit, setIsAutoSubmitting }) => {
  const { updateBooking } = useBooking();

  return useCallback(
    (result) => {
      if (!result?.acceptedTerms) return;

      setIsAutoSubmitting(true);

      Object.entries(result.acceptedTerms).forEach(([key, accepted]) => {
        if (accepted) form.setValue(key, true);
      });

      updateBooking({ terms: { ...result.acceptedTerms } });

      form.handleSubmit(onSubmit)();
    },
    [form, onSubmit, setIsAutoSubmitting, updateBooking]
  );
};
